"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.npm = exports.ns = void 0;
const NameSpace_1 = require("../utils/NameSpace");
const Prefix_1 = require("../utils/Prefix");
let base = 'http://purl.org/on/npm/';
exports.ns = (0, NameSpace_1.createNameSpace)(base);
Prefix_1.Prefix.add('npm', base);
var packageName = (0, exports.ns)('packageName');
var version = (0, exports.ns)('version');
exports.npm = {
    version,
    packageName,
};
//# sourceMappingURL=npm.js.map